export default {
    documentTypes: {
        acceptance: '検収書',
        deliveryslip: '納品書',
        invoice: '請求書',
        order: '発注書（受領）',
        orderconfirmation: '注文請書',
        orderslip: '発注書（返送用）',
        quote: '見積書',
        receipt: '領収書',
        timesheet: '作業報告書',
    },
};
